// languageSlice.js
import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'universal-cookie';
import translationEN from '../locales/en/translation.json';
import translationFR from '../locales/fr/translation.json';

const cookies = new Cookies();
cookies.set('activeLanguage', 'en', { path: '/' });
const initialState = {
  currentLanguage: 'en',
  translations: {
    en: translationEN,
    fr: translationFR,
  },
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
